import { Badge } from "@/components/ui/badge"

export default function PlannerMoveObjectiveStep() {
  return (
    <section className="flex flex-col gap-4">
      <header className="flex items-center gap-2">
        <h1 className="text-base font-bold">Mover un objetivo a otra semana</h1>
      </header>
      <img
        className="w-full object-contain"
        src="https://storage.googleapis.com/educabot-aec-cdn-1/tuni/product-tour/planner-move-objective.gif"
      />
      <p className="text-left text-sm text-muted-foreground">
        Para aprovechar mejor tu tiempo de estudio, podés mover los objetivos a la semana que
        prefieras. Si superás tu tiempo disponible, te avisamos para que puedas ajustar y seguir
        avanzando. ¡Tu progreso está en tus manos!
      </p>
      <Badge className="-mb-12 w-fit bg-primary-50 text-primary-500">
        <span className="font-semibold">Paso 4 de 8</span>
      </Badge>
    </section>
  )
}
